import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconReplay = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 20 20"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M9.663 18.333C8.621 18.333 7.646 18.135 6.736 17.740C5.826 17.344 5.035 16.809 4.361 16.135C3.687 15.461 3.152 14.670 2.757 13.760C2.361 12.850 2.163 11.875 2.163 10.833H3.830C3.830 12.458 4.457 13.837 5.711 14.969C6.965 16.101 8.621 16.667 9.663 16.667C11.288 16.667 12.666 16.101 13.799 14.969C14.931 13.837 15.496 12.458 15.496 10.833C15.496 9.208 14.931 7.830 13.799 6.698C12.666 5.565 11.288 5.000 9.663 5.000H9.538L10.830 6.292L9.663 7.500L6.330 4.167L9.663 0.833L10.830 2.042L9.538 3.333H9.663C10.705 3.333 11.680 3.531 12.590 3.927C13.500 4.323 14.291 4.858 14.965 5.531C15.639 6.205 16.174 6.996 16.569 7.906C16.965 8.816 17.163 9.792 17.163 10.833C17.163 11.875 16.965 12.850 16.569 13.760C16.174 14.670 15.639 15.461 14.965 16.135C14.291 16.809 13.500 17.344 12.590 17.740C11.680 18.135 10.705 18.333 9.663 18.333Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
